<!-- <h1 mat-dialog-title>Enter Details</h1> -->
<div mat-dialog-content>
    <div class="main-section-box">
        <h5 class="modal_title">Program Details</h5>

        <div class="fl">
            <mat-label class="mat-label">Program Name</mat-label>
            <input [(ngModel)]="jsonData.name" matInput required maxlength="65">
        </div>

        <div class="fl">
            <mat-label class="mat-label">Select Category</mat-label>
            <mat-select (selectionChange)="changeCategory($event.value)">
                <mat-option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</mat-option>
            </mat-select>
        </div>

        <div class="fl" *ngIf="subCategories.length">
            <mat-label class="mat-label">Select Sub Category</mat-label>
            <mat-select (selectionChange)="changeSubCategory($event.value)">
                <mat-option *ngFor="let subCat of subCategories" [value]="subCat.id">{{subCat.name}}</mat-option>
            </mat-select>
        </div>

        <!-- <div class="fl">
            <mat-label class="mat-label">Program Description</mat-label>
            <textarea name="Description" [(ngModel)]="jsonData.description" id="" cols="30" rows="3"></textarea>
        </div>

        <div class="fl">
            <mat-label class="mat-label">Program Image</mat-label>
            <div class="img" >
                <input type="file" (change)="onFileChange($event, 'programImage')" accept=".png,.jpg" required />
            </div>
            <div *ngIf="jsonData?.programImage" style="    flex-basis: 100%;">
                <img class="library_img" [src]="jsonData.programImage" />
            </div>
        </div>

        <div class="fl">
            <mat-label class="mat-label">Landscape Image</mat-label>
            <div class="img">
                <input type="file" (change)="onFileChange($event, 'landscapeImage')" accept=".png,.jpg" required />
            </div>
            <div *ngIf="jsonData?.landscapeImage" style="    flex-basis: 100%;">
                <img class="library_img" [src]="jsonData.landscapeImage" />
            </div>
        </div>


        <div class="fl">
            <mat-label class="mat-label">Select Difficulty Level</mat-label>
            <mat-select [(ngModel)]="jsonData.difficultyLevel">
                <mat-option value="easy">Easy</mat-option>
                <mat-option value="medium">Medium</mat-option>
                <mat-option value="hard">Hard</mat-option>
            </mat-select>
        </div>

        <div class="fl">
            <mat-label class="mat-label">Course Time</mat-label>
            <input type="text" [(ngModel)]="jsonData.courseTime" placeholder="hh:mm" matInput required>
        </div>

        <div class="fl">
            <mat-label class="mat-label">Number Of Sections</mat-label>
            <input type="number" [(ngModel)]="jsonData.numberOfSections" (input)="onClickSection($event.target.value)" matInput required>
        </div>

        <div *ngIf="jsonData.sections.length">
            <ng-container *ngFor="let section of jsonData.sections; let sectionIndex = index">
                <div class="fl">
                    <mat-label class="mat-label">Name</mat-label>
                    <input [(ngModel)]="section.name" matInput required>
                </div>

                <div class="fl">
                    <mat-label class="mat-label">Description</mat-label>
                    <textarea name="Description" [(ngModel)]="section.description" id="" cols="30" rows="3"></textarea>
                </div>

                <div class="fl">
                    <mat-label class="mat-label">Number Of Units</mat-label>
                    <input type="number" [(ngModel)]="section.numberOfUnits" matInput required>
                </div>

            </ng-container>
        </div> -->
    </div>
</div>

<div mat-dialog-actions class="actions-btns">
    <button class="cancel-btn" mat-button mat-dialog-close>Cancel</button>
    <button class="save-btn" mat-button (click)="saveProgram()">Save</button>
</div>

<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>